// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"1309e8ce","485":"61004167","500":"b4f5d06c","716":"07d34c14"}[chunkId] + ".chunk.css";
};